import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({

  textarea: {
    '& > div': {
      position: 'relative',
      height: '90px',
      width: '100%',
      // marginBottom: '18px',
    },
    '& textarea': {
      resize: 'none',
      boxSizing: 'border-box',
      position: 'absolute',
      borderRadius: '4px',
      outline: 'none',
      height: '100%',
      width: '100%',
      left: '0',
      marginTop: '8px',
      fontSize: '16px',
      fontWeight: '400',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      padding: '10px',
      border: '1px solid rgba(0, 0, 0, 0.23)',
    },
    '& textarea:hover': {
      border: '1px solid black',
    },
    '& .focused textarea': {
      border: '2px solid rgb(33, 150, 243)',
    },

    '& label': {
      userSelect: 'none',
      pointerEvents: 'none',
      zIndex: '1',
      position: 'absolute',
      top: '2px',
      left: '12px',
      background: 'white',
      fontSize: '12px',
      padding: '0 5px',
      transition: 'all ease-in-out .2s',

    },
    '& .focused label': {
      color: 'rgb(33, 150, 243)',
      top: '2px',
      left: '12px',
      fontSize: '12px',
    },
    '& .blured label.empty': {
      top: '18px',
      left: '12px',
      fontSize: '16px',
    },

  }

})